import gql from 'graphql-tag';

const GET_CATALOG = gql`
  query ($catalogSpecId: String!, $pricesheetId: String!) {
    catalog: getCatalog(catalogSpecId: $catalogSpecId, pricesheetId: $pricesheetId) {
      name,
      sections {
        groupBy,
        products {
          product {
            inRutaCode,
            category,
            inRutaShortDescriptionSpanish,
            image,
            catalog,
            itemCount,
            itemServing,
            unit
          }
          price
        }
      }
    }
  }
`;

export default GET_CATALOG;
